import { voucherConfig } from 'lib/vouchers/clientConfig';

/**
 * Signed vouchers and reassignments. Each signed voucher stores the custodian it
 * was signed for (_custodian, custodianName: set by the back). When the asset
 * changes custodian the voucher stays, locked, but it is no longer the current
 * one. Vouchers signed before _custodian existed count as "previous".
 */

// An employee as the asset or the file brings it: populated object or id.
const idOf = (value) => {
  if (!value) return '';
  if (typeof value === 'object') return String(value.id || value._id || '');
  return String(value);
};

/** 'current' if the voucher was signed for the asset's custodian, else 'previous'. */
export const voucherStatus = (file, asset) => {
  const custodian = idOf(asset && asset._employee);
  const signedFor = idOf(file && file._custodian);
  return custodian && signedFor && custodian === signedFor ? 'current' : 'previous';
};

export const custodianChanged = (before, after) => idOf(before) !== idOf(after);

/**
 * After saving an asset: remind to sign the voucher of the new custodian (only
 * a notice, nothing is generated). For clients with signIndividual and when the
 * asset now has a custodian different from the one it was loaded with.
 */
export const needsNewVoucherNotice = (company, subcompany, before, after) =>
  !!voucherConfig(company, subcompany).signIndividual &&
  !!idOf(after) &&
  custodianChanged(before, after);



// WEBPACK FOOTER //
// src/lib/vouchers/custodian.js